module.exports = __webpack_public_path__ + "stu-res/img/stop@3x.2b102b1c.png";